"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const a11y_dialog_1 = __importDefault(require("a11y-dialog"));
const modals = {
    _modals: {},
    _scrollPosition: 0,
    _init: false,
    _onOpenModal(dialog, event) {
        this._scrollPosition = window.scrollY;
        document.body.classList.add('modal-open');
        // Replace href and data-marketplace tracking code with correct info
        if (dialog.id === 'marketplace-modal') {
            dialog.querySelectorAll('a').forEach(a => {
                const button = event?.target;
                if (button && a.hasAttribute('data-marketplace')) {
                    a.setAttribute('data-marketplace', button.getAttribute('data-product-code') || '');
                    a.href = button.getAttribute('data-marketplace-url') || '';
                }
            });
        }
        window.scrollTo(0, this._scrollPosition);
        dialog.dispatchEvent(new CustomEvent('modal.show', { bubbles: true, cancelable: false }));
    },
    _onCloseModal(dialog, event) {
        document.body.classList.remove('modal-open');
        window.scrollTo(0, this._scrollPosition);
        dialog.dispatchEvent(new CustomEvent('modal.hide', { bubbles: true, cancelable: false }));
    },
    /**
     * Get modal instance.
     *
     * @param {String} id Modal html id.
     * @returns {A11yDialog|null}
     */
    getModal(id) {
        return this._modals[id] || null;
    },
    /**
     * Create new modal.
     *
     * @param {HTMLElement} el Modal container element.
     * @return {A11yDialog} Modal object.
     */
    createModal: function (el) {
        // Return existing one
        if (this._modals[el.id]) {
            return this._modals[el.id];
        }
        const modal = new a11y_dialog_1.default(el);
        modal.on('show', this._onOpenModal.bind(this));
        modal.on('hide', this._onCloseModal.bind(this));
        this._modals[el.id] = modal;
        // Add required data-attributes to links with marketplace url hash
        if (el.id === 'marketplace-modal') {
            el.querySelectorAll('a').forEach(a => {
                if (a.hash === '#MARKETPLACE_URL') {
                    a.setAttribute('data-marketplace', '');
                }
            });
        }
        // Open modal when anchor link is modal id
        const hashLinkToggle = (e) => {
            try {
                const modalId = e.currentTarget?.dataset?.modalLink || e.currentTarget?.hash?.replace('#', '');
                const modal = this._modals[modalId];
                if (modal) {
                    modal.show();
                    e.preventDefault();
                }
            }
            catch (_) {
                // Ignore, bubbles to parent if needed
            }
        };
        document.querySelectorAll(`a[href*="#${el.id}"]`).forEach(a => {
            a.addEventListener('click', hashLinkToggle);
        });
        // Add modal link to all elements with data-modal-link attribute.
        document.querySelectorAll('[data-modal-link]').forEach(a => {
            a.addEventListener('click', hashLinkToggle);
        });
        // Set input method
        const ids = Object.keys(this._modals);
        const prevMethod = ids.length > 0 ? this._modals[ids[0]].container.getAttribute('data-input-method') : false;
        modal.container.setAttribute('data-input-method', prevMethod || 'mouse');
        // Trigger event on modal when button is clicked
        const buttons = el.querySelectorAll('[data-modal-v2-button]');
        buttons.forEach(button => {
            button.addEventListener('click', (e) => {
                const buttonEvent = new CustomEvent('modal.button', {
                    bubbles: true,
                    cancelable: true,
                    detail: { type: e.target?.dataset.modalV2Button, button }
                });
                if (el.dispatchEvent(buttonEvent)) {
                    modal.hide();
                }
            });
        });
        return modal;
    },
    /**
     * Removes modal instance.
     *
     * @param {String} id Modal html id.
     */
    removeModal(id) {
        if (this._modals[id]) {
            this._modals[id].destroy();
            delete this._modals[id];
        }
    },
    /**
     * Get all modals.
     *
     * @returns {Object} Modal html id mapped to A11yDialog.
     */
    getModals() {
        return this._modals;
    },
    /**
     * Initializes modals.
     *
     * @param {NodeList|false} modals Modals to initialize. If empty, queries modals from dom.
     */
    init(modals = false) {
        if (this._init) {
            return;
        }
        this._init = true;
        console.log('modal: init()', modals);
        const setModalInputMethod = (method) => {
            for (let id in this._modals) {
                this._modals[id].container.setAttribute('data-input-method', method);
            }
        };
        document.addEventListener('keydown', () => {
            setModalInputMethod('keyboard');
        });
        document.addEventListener('mousedown', () => {
            setModalInputMethod('mouse');
        });
        document.addEventListener('touchstart', () => {
            setModalInputMethod('touch');
        });
        const elements = modals || document.querySelectorAll('[data-modal], [data-modal-v2]');
        elements.forEach(modal => {
            this.createModal(modal);
        });
    }
};
exports.default = modals;
